module.exports = __webpack_public_path__ + "static/media/spinner.71af768e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/spinner.gif
// module id = 2672
// module chunks = 0